import axios from 'axios';
/**
 *  Get a list of hotel locations
 *  @returns {Promise}
 */
let promise1 = new Promise((resolve, reject) => {
    axios.get('/direct/ajax-widget.php?source=home')
        .then(res => resolve(res.data))
        .catch(error => reject(error))
});
let promise2 = new Promise((resolve, reject) => {
    let pathname = window.location.pathname;
    if(pathname.includes('hotels-resorts')) {
    axios.get('/direct/ajax-widget.php?source=/')
        .then(res => resolve(res.data))
        .catch(error => reject(error))
    } else {
    axios.get(`/direct/ajax-widget.php?source=${pathname}`)
        .then(res => resolve(res.data))
        .catch(error => reject(error))
    }
});

export function getLocations() {
  const deferred = new $.Deferred();
  Promise.all([promise1, promise2]).then(function(data){
      const arr = {}
      arr['home'] = data[0]
      arr['widget'] = data[1]
      deferred.resolve(arr);
  }).catch(e => {
      deferred.reject(e);
      console.log('Error ',  e);
  })
   return deferred;
}

// let promise1 = new Promise((resolve, reject) => {
//     $.get('/us/xml/property.php', response => {
//         const $items = $(response).find('data > item');
//         resolve($items);
//     }).fail(reject);
// });
// let promise2 = new Promise((resolve, reject) => {
//     $.get('/xml/property.php', response => {
//         const $items = $(response).find('data > item');
//         resolve($items);
//     }).fail(reject);
// });
// export function getLocations() {
//   const deferred = new $.Deferred();
//   Promise.all([promise1, promise2]).then(function(data){
//       const arr = []
//       arr.push(data[0])
//       arr[0].push(...data[1])
//       deferred.resolve(arr[0]);
//   }).catch(e => {
//       deferred.reject(e);
//       console.log('Error ',  e);
//   })
//    return deferred;
// } 

 /*
export function getLocations() {
    const deferred = new $.Deferred();
  
    $.get('/xml/property.php', response => {
      const $items = $(response).find('data > item');
      deferred.resolve($items);
    }).fail(deferred.reject);
  
    return deferred;
  }
  */

  
  //Get medis gallery list
export function getMediaGallery(isConnectFast) {
     const deferred = new $.Deferred();
     $.get(
       `/direct/ajax-gallery.php?property=${window.location.pathname.replace('/', '').replace('media-gallery.php', '')}&lb=${isConnectFast}`,
       response => {
         deferred.resolve(response);
       }
     ).fail(deferred.reject);
     return deferred;
}

export function getAccommodationSilder() {
     const deferred = new $.Deferred();
     $.get(`/direct/ajax-accommodations.php`, response => {
     const sliderImage = JSON.parse(response.replace(/\\/g, ''));
    deferred.resolve(sliderImage);
    }).fail(
        deferred.reject
        );
        return deferred;
}
  //getAccommodationSilder()
  
  export function getHistorySilder() {
    const deferred = new $.Deferred();
    $.get(`/direct/ajax-history-slider.php`, response => {
    const sliderImage = JSON.parse(response.replace(/\\/g, ''));
    deferred.resolve(sliderImage);
   }).fail(
       deferred.reject
       );
       return deferred;
  }

export function getGolfSilder() {
    const deferred = new $.Deferred();
    $.get(`/direct/ajax-golf-slider.php`, response => {
        const sliderImage = JSON.parse(response.replace(/\\/g, ''));
        deferred.resolve(sliderImage);
    }).fail(
        deferred.reject
    );
    return deferred;
}

  export function getTimelineHistorySilder() {
    const deferred = new $.Deferred();
    $.get(`/direct/ajax-timeline-history-slider.php`, response => {
    const sliderImage = JSON.parse(response);
    deferred.resolve(sliderImage);
   }).fail(
       deferred.reject
       );
       return deferred;
  }

export function getTimelineGolfSilder() {
    const deferred = new $.Deferred();
    $.get(`/direct/ajax-timeline-golf-slider.php`, response => {
        const sliderImage = JSON.parse(response);
        deferred.resolve(sliderImage);
    }).fail(
        deferred.reject
    );
    return deferred;
}

  export function getPOIAirports(phg_id) {
    const deferred = new $.Deferred();
  
    $.get(`/direct/ajax-poi.php?phgid=${phg_id}`, response => {
      deferred.resolve(response);
    }).fail(deferred.reject);
  
    return deferred;
  }
  
  export function getAccommodationPushmarket(page,isAmerica) {
      const deferred = new $.Deferred();
      $.get(`${isAmerica}/direct/ajax-pushmarketing.php?page=${page}`, response => {
          const pushMarketData = JSON.parse(response.replace(/\\/g, ''));
          deferred.resolve(pushMarketData);
      }).fail(
          deferred.reject
      );
      return deferred;
  }
  
  export function getReviewsPushMarket(page,isAmerica) {
      const deferred = new $.Deferred();
      $.get(`${isAmerica}/direct/ajax-pushmarketing.php?page=${page}`, response => {
          const pushMarketData = JSON.parse(response.replace(/\\/g, ''));
          deferred.resolve(pushMarketData);
      }).fail(
          deferred.reject
      );
      return deferred;
  }
  
  export function getOverviewPushMarket(page,isAmerica) {
      const deferred = new $.Deferred();
      $.get(`${isAmerica}/direct/ajax-pushmarketing.php?page=${page}`, response => {
          const pushMarketData = JSON.parse(response.replace(/\\/g, ''));
          deferred.resolve(pushMarketData);
      }).fail(
          deferred.reject
      );
      return deferred;
  }
  
  export function getDiningPushMarket(page,isAmerica) {
      const deferred = new $.Deferred();
      $.get(`${isAmerica}/direct/ajax-pushmarketing.php?page=${page}`, response => {
          const pushMarketData = JSON.parse(response.replace(/\\/g, ''));
          deferred.resolve(pushMarketData);
      }).fail(
          deferred.reject
      );
      return deferred;
  }
  
  export function getLocationPushMarket(page,isAmerica) {
      const deferred = new $.Deferred();
      $.get(`${isAmerica}/direct/ajax-pushmarketing.php?page=${page}`, response => {
          const pushMarketData = JSON.parse(response.replace(/\\/g, ''));
          deferred.resolve(pushMarketData);
      }).fail(
          deferred.reject
      );
      return deferred;
  }
  
  export function getMeetingsPushMarket(page,isAmerica) {
      const deferred = new $.Deferred();
      $.get(`${isAmerica}/direct/ajax-pushmarketing.php?page=${page}`, response => {
          const pushMarketData = JSON.parse(response.replace(/\\/g, ''));
          deferred.resolve(pushMarketData);
      }).fail(
          deferred.reject
      );
      return deferred;
  }

  export function getCafeduparcPushMarket(page,isAmerica) {
    const deferred = new $.Deferred();
    $.get(`${isAmerica}/direct/ajax-pushmarketing.php?page=${page}`, response => {
        const pushMarketData = JSON.parse(response.replace(/\\/g, ''));
        deferred.resolve(pushMarketData);
    }).fail(
        deferred.reject
    );
    return deferred;
}


